<template>
  <div class="brand-logo">
    <b-img
      v-if="logo"
      :src="logo"
      :alt="`${appNameSlug}-logo`"
      :width="logoWidth"
    />
    <span>{{ displayName }}</span>
  </div>
</template>

<script>
import {$themeConfig} from '@themeConfig'

export default {
  name: 'AppLogo',
  props: {
    appName: {
      type: String,
      required: true
    },
    appId: {
      type: [String, Number],
      default: null // optional fallback
    }
  },
  computed: {
    displayName () {
      return this.appName || `App ID: ${this.appId ?? 'N/A'}`
    },
    appNameSlug () {
      return this.appName?.toLowerCase().replace(/\s+/g, '-')
    },
    logoWidth () {
      return this.appName === 'Prime Opinion' ? '20px' : '25px'
    },
    logo () {
      const logos = {
        'Prime Opinion': $themeConfig.app.appLogoImage,
        'Five Surveys': $themeConfig.app.fiveSurvesLogoImage,
        'HeyCash': $themeConfig.app.heyCashLogoImage,
        'TopSurveys': $themeConfig?.app?.topSurveysLogoImage,
        'EarnStar': $themeConfig.app.earnStarLogoImage
      }

      return logos[this.appName] || null
    }
  }
}
</script>
